import { FC } from 'react'
import { SentimentBreakdown } from 'src/services/__generated__/api'
import styles from './sentimentSplit.module.scss'

interface SentimentSplitProps {
  breakdown: SentimentBreakdown
}

// Sentiment palette used across the inbox pages.
const SEGMENTS = [
  { color: '#8080ff', key: 'positive', label: 'Positive' },
  { color: '#c7ced1', key: 'neutral', label: 'Neutral' },
  { color: '#ff6833', key: 'negative', label: 'Negative' },
] as const

// One stacked bar (positive / neutral / negative) plus a legend row per
// sentiment with its share and count — the body of Total Chats / Messages.
export const SentimentSplit: FC<SentimentSplitProps> = ({ breakdown }) => (
  <div className={styles.split}>
    <div className={styles.bar}>
      {SEGMENTS.map(({ color, key }) =>
        (breakdown[key].count ?? 0) > 0 ? (
          <span
            className={styles.segment}
            key={key}
            style={{
              backgroundColor: color,
              flexGrow: breakdown[key].count ?? 0,
            }}
          />
        ) : null
      )}
    </div>
    <ul className={styles.legend}>
      {SEGMENTS.map(({ color, key, label }) => (
        <li className={styles.row} key={key}>
          <span className={styles.dot} style={{ backgroundColor: color }} />
          <span className={styles.share}>
            {breakdown[key].percentage ?? 0}%
          </span>
          <span className={styles.label}>{label}</span>
          <span className={styles.count}>
            {(breakdown[key].count ?? 0).toLocaleString('en-US')}
          </span>
        </li>
      ))}
    </ul>
  </div>
)
